import '@fontsource-variable/inter';
import './global.css';
import './i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { checkEnv } from './lib/envCheck';
import { syncAnalyticsProvider } from './analytics';
import { initSentry } from './lib/sentry';
import { setupMobileDeepLinks } from './lib/mobileDeepLinks';
import { captureAttribution } from './lib/attribution';
import App from './App';
import { ErrorBoundary } from './ErrorBoundary';

checkEnv();
initSentry();
syncAnalyticsProvider();
void setupMobileDeepLinks();
// First-touch marketing attribution (non-sensitive, localStorage only).
captureAttribution();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Could not find root element to mount to');
}

document.getElementById('dg-boot-fallback')?.remove();

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
